export default "__VITE_ASSET__DuBhgZED__"